import { defineRoutes } from "@/service/routing/schema";

const base = "/subskrypcja";

export const subscriptionRoutes = defineRoutes({
  "subscription.index": () => `${base}`,
  "subscription.show": ({ slug }: { slug: string }) => `${base}/${slug}`,
  "subscription.introduction": ({ slug }: { slug: string }) =>
    `${base}/${slug}/wprowadzenie`,
  "subscription.subscribe": ({ slug }: { slug: string }) =>
    `${base}/${slug}/subskrybuj`,
  "subscription.subscribe.sign_contract": ({ slug }: { slug: string }) =>
    `${base}/${slug}/subskrybuj/podpisz-umowe`,
  "subscription.subscribe.success": ({ slug }: { slug: string }) =>
    `${base}/${slug}/subskrybuj/sukces`,
  "subscription.manage": ({ slug }: { slug: string }) =>
    `${base}/${slug}/zarzadzaj`,
  "subscription.virtual_email": () => `${base}/wirtualne-biuro/wirtualny-email`,
  "subscription.virtual_email_detail": ({ id }: { id: string | number }) =>
    `${base}/wirtualne-biuro/wirtualny-email/${id}`,
  "subscription.virtual_phone": () => `${base}/wirtualne-biuro/prywatny-numer`,
  // Publiczny landing usługi — poza /subskrypcja, bo prowadzi na niego ruch z reklam.
  "subscription.virtual_office.landing": () => `/wirtualny-gabinet`,
} as const);
